import * as React from "react";
import { useState } from "react";
import ToggleButton from "../commons/components/buttons/ToggleButton";
import { ModalWarning } from "../commons/components/modal/ModalWarning";

export interface PracticeQuestionOverrideFormSettings {
  practiceQuestionOverride: boolean;
  updatePracticeQuestionOverrideUrl?: string;
  displayUserQuestionnaireStep?: boolean;
  updateDisplayUserQuestionnaireStepUrl?: string;
}

export default function SettingPracticeQuestionOverrideForm({
  practiceQuestionOverrideFormSettings,
  onPracticeOverrideQuestionsChangeToggle,
  onDisplayUserQuestionnaireStepChangeToggle,
}: {
  practiceQuestionOverrideFormSettings: PracticeQuestionOverrideFormSettings;
  onPracticeOverrideQuestionsChangeToggle: (value: boolean) => void;
  onDisplayUserQuestionnaireStepChangeToggle: (value: boolean) => void;
}) {
  const [displayWarning, setDisplayWarning] = useState(false);

  const handlePracticeQuestionOverrideToggleChange = (value: boolean) => {
    if (!value) {
      setDisplayWarning(true);
    } else {
      onPracticeOverrideQuestionsChangeToggle(true);
    }
  };

  return (
    <>
      {practiceQuestionOverrideFormSettings.updatePracticeQuestionOverrideUrl && (
        <div className="no-label-field-groups toggle">
          <h3 className="title">
            {isDmipPlatform &&
              i18n[
                "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.PracticeAndDoctors.Toggle.Title"
              ]}
            {!isDmipPlatform &&
              i18n[
                "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.Doctors.Toggle.Title"
              ]}
          </h3>
          <ToggleButton
            id={"practice-question-override-toggle"}
            value={practiceQuestionOverrideFormSettings.practiceQuestionOverride}
            onChange={handlePracticeQuestionOverrideToggleChange}
          />
          {displayWarning && (
            <ModalWarning
              action={async () => {
                setDisplayWarning(false);
                onPracticeOverrideQuestionsChangeToggle(false);
              }}
              cancel={() => setDisplayWarning(false)}
              title={
                i18n[
                  "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.DisableModal.Title"
                ]
              }
              actionButtonLabel={
                i18n[
                  "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.DisableModal.Disable"
                ]
              }
            >
              <p>
                {
                  i18n[
                    "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.DisableModal.Content"
                  ]
                }
              </p>
            </ModalWarning>
          )}
        </div>
      )}
      {practiceQuestionOverrideFormSettings.updateDisplayUserQuestionnaireStepUrl && (
        <div className="no-label-field-groups toggle">
          <h3 className="title">
            {
              i18n[
                "Page.Settings.VirtualConsultation.Customization.Form.Questionnaire.Display.Toggle.Title"
              ]
            }
          </h3>
          <ToggleButton
            id={"display-user-questionnaire-step-toggle"}
            value={practiceQuestionOverrideFormSettings.displayUserQuestionnaireStep}
            onChange={onDisplayUserQuestionnaireStepChangeToggle}
          />
        </div>
      )}
    </>
  );
}
